import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-top"
export default class extends Controller {
  static values = {
    threshold: { type: Number, default: window.innerHeight }
  }

  initialize () {
    this.checkVisibility = this.checkVisibility.bind(this)
  }

  connect () {
    window.addEventListener("scroll", this.checkVisibility)
    this.checkVisibility()
  }

  disconnect () {
    window.removeEventListener("scroll", this.checkVisibility)
  }

  checkVisibility () {
    this.element.classList.toggle("is-visible", window.scrollY > this.thresholdValue)
  }

  scroll (event) {
    event.preventDefault()

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
}
